// extracted by mini-css-extract-plugin
export var quantityInput = "_jh-0";